import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { Provider as JotaiProvider } from "jotai";

// Import our css
import "./index.scss";

// Import our app components
import { App } from "./components";

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <StrictMode>
    <JotaiProvider>
      <App />
    </JotaiProvider>
  </StrictMode>
);
